import request from '@/utils/request';
import { ApiPrefix } from '@/constants/constants';
export default {
	captchaKey: () => {
		return request({
			url: ApiPrefix.AuthDefault + '/auth/captcha/key',
			method: 'get',
		});
	},
	captchaRender: (key: string) => {
		return request({
			url: ApiPrefix.AuthDefault + '/auth/captcha/render/' + key,
			method: 'get',
		});
	},
	getSms: (phoneNum: string | number) => {
		return request({
			url: ApiPrefix.AuthDefault + `/auth/login/sms/${phoneNum}`,
			method: 'get',
		});
	},
	accountLogin: (data?: object) => {
		return request({
			url: ApiPrefix.AuthDefault + '/auth/login/account',
			method: 'post',
			data,
		});
	},
	logout: () => {
		return request({
			url: ApiPrefix.AuthDefault + '/auth/logout',
			method: 'get',
		});
	},
	authorize: () => {
		return request({
			url: ApiPrefix.AuthDefault + '/auth/authorize',
			method: 'get',
		});
	},
	token: (access_code: string) => {
		return request({
			url: ApiPrefix.AuthDefault + '/auth/token/' + access_code,
			method: 'get',
		});
	},
	account: () => {
		return request({
			url: ApiPrefix.SysDefault + '/account',
			method: 'get',
		});
	},
	refresh: (refresh_token?: string) => {
		return request({
			headers: { 'Content-Type': 'text/plain' },
			url: ApiPrefix.AuthDefault + '/auth/token/refresh',
			method: 'post',
			data: refresh_token,
		});
	},

	// 租户检查
	checkTenant: () => {
		return request({
			url: ApiPrefix.SysDefault + '/account/tenant/check',
			method: 'get',
		});
	},

	// 获取租户列表数据
	getTenant: () => {
		return request({
			url: ApiPrefix.SysDefault + '/account/tenant/list',
			method: 'get',
		});
	},

	// 设置租户
	setTenant: (data?: object) => {
		return request({
			url: ApiPrefix.SysDefault + '/account/tenant/select',
			method: 'post',
			data,
		});
	},

	// 获取权限数据
	getPermissionData: () => {
		return request({
			url: ApiPrefix.SysDefault + '/account/permission/data',
			method: 'get',
		});
	},
	// 获取当前租户开通的产品列表
	getKtfwByMy: (data?: object) => {
		return request({
			url: ApiPrefix.SysDefault + '/product/refkz/getKtfwByMy',
			method: 'get',
			params: data,
		});
	},

	// 账号认领
	claimAccount: (data?: object) => {
		return request({
			url: ApiPrefix.SysDefault + '/account/claim/update',
			method: 'put',
			data,
		});
	},
};
